import { AfterViewInit, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import { AdminRoleService } from 'src/app/_api/services/role.service';
import { TimeStatusLogsService } from 'src/app/_api/services/timestatuslogs.service';
import { LanguageService } from 'src/app/shared/services/language.service';

@Component({
  selector: 'app-project-portal-log-detail-grid',
  templateUrl: './project-portal-log-detail-grid.component.html',
  styleUrls: ['./project-portal-log-detail-grid.component.css']
})
export class ProjectPortalLogDetailGridComponent implements AfterViewInit {
  @Input() key: Date; 
  @Input() selectedTimeRecord: any;
  @Input() firstPreviousStatusId: number; 

  timelogs = []; 
  statuses = []; 
  statusLogs = []; 

  logsDataSource: DataSource;

  constructor(private timeLogService: TimeStatusLogsService, public languageService: LanguageService, private _adminRoleService: AdminRoleService) { 
  }

  ngAfterViewInit(): void {
    this.loadStatuses(); 
    this.loadData(); 
  }

  private async loadData() {
    if (!this.selectedTimeRecord) { 
      this.timelogs = []; 
      return; 
    }

    this.logsDataSource = new DataSource({
      store: new ArrayStore({
        data: this.timelogs,
        key: 'Date',
      }),
      filter: ['Date', '=', this.key],
    })

    const asyncOperations: Promise<any>[] = [
      this.loadStatusLogsFromDate(),
    ];

    await Promise.all(asyncOperations);
  }

  public getStatusText(statusId: number): string {
    if(statusId == null) return ""
    let status = this.statuses.find(s => s.StatusId === statusId);
    return status?.Description 
  }

  public getStatusStyleValue(statusId: number): string {
    let status = this.statuses.find(s => s.StatusId === statusId);
    if(status?.HTMLSettingStyleValue == null || statusId == null) return ""
    let style = `background: linear-gradient(to left, ${status.HTMLSettingStyleValue} 50px, rgba(0,0,0,0) 50px);`
    return style
  }

  private async loadStatusLogsFromDate() {
    this.timelogs = await this.timeLogService.getByDateAndTimeId(this.key, this.selectedTimeRecord.TimeId).toPromise();
    if(this.firstPreviousStatusId > -1 && this.timelogs.length > 0) {
      this.timelogs[0].OldStatusId = this.firstPreviousStatusId; 
    }
  } 

  private async loadStatuses() {
    this.statuses = await this._adminRoleService.getAllStatuses().toPromise();
  }

}
